import { render, staticRenderFns } from "./OptionSchedulePost.vue?vue&type=template&id=485696e0&"
import script from "./OptionSchedulePost.vue?vue&type=script&lang=ts&"
export * from "./OptionSchedulePost.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports